import React, { Component } from 'react';
import ReactEcharts from "echarts-for-react";

class China extends Component {

    getOption = () => {
        console.log(this.props.data)
        return {
            series: [
                {

                    type: 'pie',
                    radius: ['55%', '66%'],
                    // bottom:30,
                    // roseType:"radius",
                    label: {
                        show: false,
                        // position:"inside",
                        // color:"#fff",
                        // backgroundColor:"#155cab",
                        // borderRadius:500,
                        // width:30,
                        // height:30,
                        // lineHeight:30,
                        // fontSize: 12,
                        // rich:{}
                        bleedMargin:-100,
                        // rotate:-90,
                        formatter:(a,b,c)=>{
                            console.log(a,b,c)
                            return a.data.label
                        },
                        fontStyle :"oblique",
                        // alignTo:'edge',
                        margin:'10%',
                        align:"top"
                    },

                   
                    labelLine: {
                        show: false,
                        length: 1,
                        length2: 1
                    },
                    data: this.props.data || []
                }
            ],
            color : [ '#dcffb0', '#ffa4a6', 'yellow', 'green', 'blue', 'indigo', 'purple' ],
            
        }
    }
    render() {
        const lv = (this.props.data[0].value/(this.props.data[1].value + this.props.data[0].value)*100 || 0).toFixed(2) + '%'
        return <>
            <ReactEcharts
                style={{
                    width: '100%',
                    height: "100%",
                    // padding: '50px 10px 10px 10px'
                }}
                option={this.getOption()}
                theme="clear"
            />
            <div className='pielv'>
                <p>报到率</p>
                <p>{lv}</p>
            </div>
            <p className='tonhji'>{this.props.data[1].label}</p>
            <p className='tonhjijj'>{this.props.data[0].label}</p>
        </>
    }
}
export default China
